import React, {Component} from "react";
import Link from "../../../../lib/components/Link/Link";
import PropTypes from "prop-types";

class LinkCard extends Component {

  render() {
    let bgColor = 'bg-white/5';
    if (this.props.bgColor) {
      bgColor = this.props.bgColor;
    }
    return <Link to={this.props.link} asHref className={'group sm:col-span-' + this.props.numOfColumns +
      ' lg:col-span-' + this.props.numOfColumns + ' block p-5 rounded-xl border border-white/10 ' + bgColor +
      ' hover:-translate-y-1 transition-all hover:shadow-xl bg-gradient-to-br from-kiwiAcc to-green-500 text-black'}>

      <span className="text-xs px-3 py-1 rounded-full bg-white/60">{this.props.title}</span>
      <h3 className="mt-2 text-lg font-medium text-black">{this.props.subtitle}</h3>
      <p className="text-sm mt-2 opacity-90 text-black">{this.props.description}</p>
      <span className="inline-flex items-center gap-1 mt-4 font-semibold">Mehr
              <span className="transform transition group-hover:translate-x-1">→</span>
            </span>
    </Link>;
  }
}

LinkCard.propTypes = {
  link: PropTypes.string,
  numOfColumns: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  bgColor: PropTypes.string
}
export default LinkCard;
